var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "180",
      "height": "74",
      "viewBox": "0 0 180 74",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M0 0h15.91v1H0z"
    }
  }), _c('path', {
    attrs: {
      "id": "c",
      "d": "M0 0h38.182v1H0z"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(99.636 72.147)"
    }
  }, [_c('mask', {
    attrs: {
      "id": "b",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })]), _c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "mask": "url(#b)",
      "d": "M0 .5h15.909"
    }
  })]), _c('g', {
    attrs: {
      "transform": "translate(59.333 72.147)"
    }
  }, [_c('mask', {
    attrs: {
      "id": "d",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#c"
    }
  })]), _c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "mask": "url(#d)",
      "d": "M0 .5h38.182"
    }
  })]), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m92.896 57.168-5.06 5.06v8.65l5.06-5.123z"
    }
  }), _c('g', [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "d": "M87.836 72.412h5.06V38h-5.06z"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.59 3.979 69.85 38.166a.897.897 0 0 0 .777 1.345h39.476a.897.897 0 0 0 .776-1.345L91.143 3.979a.897.897 0 0 0-1.554 0",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M90.366 8.896 74.498 36.38h31.736z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "m87.836 55.733 5.06-5.06v-8.586l-5.06 5.06zM90.371 30.324c1.498 0 2.246.75 2.246 2.247 0 1.498-.748 2.247-2.246 2.247s-2.246-.749-2.246-2.247c0-1.498.748-2.247 2.246-2.247zm-.957-1.876-1.57-9.127a2.85 2.85 0 0 1-.04-.46c0-1.31.856-1.965 2.567-1.965 1.71 0 2.566.65 2.566 1.952 0 .179-.013.337-.038.473l-1.57 9.127h-1.915z"
    }
  }), _c('path', {
    attrs: {
      "d": "M164.634 18.644h-7.688a4.793 4.793 0 0 0-6.21-4.39 6.905 6.905 0 0 0-6.444-4.437c-.349 0-.688.034-1.023.084a9.786 9.786 0 0 0-17.88-.07c-.095-.004-.189-.014-.286-.014a6.908 6.908 0 0 0-6.907 6.908c0 .667.099 1.309.275 1.919h-3.752M141.795 22.886h4.718m2.102 0h30.302M1.265 49.932h30.758M34.144 49.932h3.182M23.538 44.894h11.945c-.004-.089-.013-.176-.013-.265a5.304 5.304 0 0 1 5.303-5.303c1.248 0 2.392.433 3.298 1.155a7.157 7.157 0 0 1 6.777-4.868 7.154 7.154 0 0 1 6.518 4.21 5.274 5.274 0 0 1 2.232-.497 5.304 5.304 0 0 1 5.304 5.303c0 .09-.01.176-.014.265h4.186M132.164 45.159a4.872 4.872 0 0 1-.556-2.26 4.896 4.896 0 0 1 9.643-1.198 3.37 3.37 0 0 1 2.038-.686 3.39 3.39 0 0 1 3.304 4.144h8.549m2.388 0h3.826",
      "stroke": "currentColor",
      "stroke-linecap": "round"
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }